import { render, staticRenderFns } from "./CbsTableView.vue?vue&type=template&id=24bae7a8&scoped=true"
import script from "./CbsTableView.vue?vue&type=script&lang=js"
export * from "./CbsTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bae7a8",
  null
  
)

export default component.exports